<template>
  <ASiteContainer>
    <h1 class="text-center sm:text-left text-3xl font-black">
      {{ $t("pages.destinations.index.title") }}
    </h1>

    <p class="mt-4 max-w-3xl sm:text-left text-center">
      {{ $t("pages.destinations.index.description") }}
    </p>

    <div class="mt-5 -mb-2">
      <p class="text-lg font-bold pb-1">
        {{ $t("components.resources.destinations.searchDestination.title") }}
      </p>
      <SearchDestination />
    </div>

    <APageSection
      v-if="
        featuredDestinations?.length
          && (!$route.query.page || Number($route.query.page) === 1)
      "
      :title="$t('pages.destinations.actuallyIn')"
    >
      <ImagesCarousel
        :title-attrs="{ class: 'text-2xl font-bold' }"
        :items="featuredDestinations"
        size="xl"
        :breakpoints="{
          320: { slidesPerView: 'auto' },
          767: { slidesPerView: 1.2 },
          930: { slidesPerView: 2.2 },
          1155: { slidesPerView: 3.2 },
          1350: { slidesPerView: 4.2 },
        }"
      />
    </APageSection>

    <APageSection :title="$t('pages.destinations.allDestinations')">
      <DestinationsPaginate />
    </APageSection>

    <APageSection>
      <div class="mt-8 space-y-6">
        <div>
          <h3 class="text-lg font-bold mb-2">
            {{ $t("pages.destinations.bestTripDestinations.title") }}
          </h3>
          <p class="text-gray-600">
            {{ $t("pages.destinations.bestTripDestinations.description") }}
          </p>
        </div>
        <div>
          <h3 class="text-lg font-bold mb-2">
            {{ $t("pages.destinations.whyChooseOurDestination.title") }}
          </h3>
          <p class="text-gray-600">
            {{ $t("pages.destinations.whyChooseOurDestination.description") }}
          </p>
        </div>
        <div>
          <h3 class="text-lg font-bold mb-2">
            {{ $t("pages.destinations.planifyYourBestTrip.title") }}
          </h3>
          <p class="text-gray-600">
            {{ $t("pages.destinations.planifyYourBestTrip.description") }}
          </p>
        </div>
      </div>
    </APageSection>
  </ASiteContainer>
</template>

<script lang="ts" setup>
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    de: '/reiseziele',
    en: '/destinations',
    es: '/destinos',
    fr: '/destinations',
    it: '/destinazioni',
    nl: '/reisbestemmingen',
    pt: '/destinos',
  },
})

const { t } = useI18n()

const { data: featuredDestinations, error: featuredDestinationsError }
  = await useFetch('/api/destinations/featured')
assertDefined(featuredDestinations, featuredDestinationsError)

useSeoMeta({
  description: t('pages.destinations.index.description'),
  ogDescription: t('pages.destinations.index.description'),
  ogTitle: t('pages.destinations.index.metaTitle'),
  title: t('pages.destinations.index.metaTitle'),
})
</script>

<style></style>
